import React from 'react';
import { Segment, Header, Label, Icon, Button, Grid } from 'semantic-ui-react';
import { CampaignResponseDto } from '../../types/campaigns.types';
import GlassmorphismTheme from '../../styles/glassmorphism';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface CampaignSummaryCardProps {
  campaign: CampaignResponseDto;
}

const CampaignSummaryCard: React.FC<CampaignSummaryCardProps> = ({ campaign }) => {
  const navigate = useNavigate();
  const { hasRole } = useAuth();
  const isAdmin = hasRole('Admin');

  const formatMonth = (mesReferencia: string) => {
    const [year, month] = mesReferencia.split('-');
    const monthNames = [
      'Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
      'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'
    ];
    return `${monthNames[parseInt(month) - 1]} ${year}`;
  };

  return (
    <Segment style={GlassmorphismTheme.components.glassCardDark}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '1rem' }}>
        <Header as="h3" style={{ color: GlassmorphismTheme.colors.solid.textLight, margin: 0 }}>
          <Icon name="bullhorn" />
          Campanha Ativa
        </Header>
        {campaign.ativa ? (
          <Label color="green" horizontal>
            <Icon name="check circle" /> Ativa
          </Label>
        ) : (
          <Label color="red" horizontal>
            <Icon name="times circle" /> Inativa
          </Label>
        )}
      </div>

      <Grid stackable columns={2}>
        <Grid.Column>
          <div style={{ marginBottom: '1rem' }}>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, opacity: 0.8, fontSize: '0.9em', marginBottom: '4px' }}>
              Nome da Campanha
            </div>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, fontSize: '1.1em', fontWeight: 600 }}>
              {campaign.nome}
            </div>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, opacity: 0.8, fontSize: '0.9em', marginBottom: '4px' }}>
              Mês de Referência
            </div>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, fontSize: '1.1em', fontWeight: 600 }}>
              {formatMonth(campaign.mesReferencia)}
            </div>
          </div>
        </Grid.Column>

        <Grid.Column>
          <div style={{ marginBottom: '1rem' }}>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, opacity: 0.8, fontSize: '0.9em', marginBottom: '4px' }}>
              Meta da Empresa
            </div>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, fontSize: '1.1em', fontWeight: 600 }}>
              R$ {campaign.metaEmpresa.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </div>
          </div>

          <div style={{ marginBottom: '1rem' }}>
            <div style={{ color: GlassmorphismTheme.colors.solid.textLight, opacity: 0.8, fontSize: '0.9em', marginBottom: '4px' }}>
              Regras de Bonificação
            </div>
            <div>
              {campaign.bonificationRules ? (
                <Label color="blue" horizontal>
                  <Icon name="settings" /> Configuradas
                </Label>
              ) : (
                <Label color="grey" horizontal>
                  Não configuradas
                </Label>
              )}
            </div>
          </div>
        </Grid.Column>
      </Grid>

      {isAdmin && (
        <div style={{ marginTop: '1rem', paddingTop: '1rem', borderTop: '1px solid rgba(255,255,255,0.1)', display: 'flex', gap: '10px' }}>
          <Button
            primary
            icon="external alternate"
            content="Gerenciar Campanha"
            onClick={() => navigate('/campaigns/dashboard')}
            style={GlassmorphismTheme.components.buttonPrimary}
          />
        </div>
      )}
    </Segment>
  );
};

export default CampaignSummaryCard;

